import { useDispatch } from "react-redux";
import { useContext, useEffect } from "react";
import styles from "./pokemon.module.css";
import global from "../../app.module.css";
import { Button } from "@mui/material";
import { usePokeSelector } from "./reducers/store";
import { selectItems } from "./reducers/reducer";
import { getPokeInfo } from "./reducers/actions";
import CartContext from "../../context/global-context";

function PokemonComponent(props) {
    const dispatch = useDispatch();
    const items = usePokeSelector(selectItems);
    const cartCtx = useContext(CartContext);
    console.log('PokemonComponent.start', cartCtx.data);

    useEffect(() => {
        if (items) {
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items]);

    const loadUserHandler = () => {
        cartCtx.addItem({
            name: 'user',
            key: 'key1'
        });
    }

    const findPokemon = () => {
        dispatch(getPokeInfo());
    }

    return ( 
        <div className={`${styles.contenedor} ${global.background}`}>
          <div className={styles.container} id="container">
                <div className={styles.loginCentrado}>
                    { 
                        !items ?  
                        <img className={global.logoImage} src='http://avanti-it.co/assets/img/Logo.png' alt="logo"/> :
                        <img className={global.logoImage} src={items.sprites['front_default']} alt="logo"/>
                    }
                    
                    <div className={`${global.row}`}>
                        <h4>POKEMON</h4>
                    </div>
                    { 
                        cartCtx.data ? <img className={global.logoImage} src={cartCtx.data.sprites['front_default']} alt="logo"/> : ''
                    }
                    <div className={`${global.row}`}>
                        <Button 
                            onClick={() => findPokemon()} 
                            variant="contained" 
                            className={`${styles.btn} ${styles.center}`}><span>Change Pokemon</span>
                        </Button>
                        <Button 
                            onClick={() => loadUserHandler()} 
                            variant="contained" 
                            className={`${styles.btn} ${styles.center}`}><span>Add User</span>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PokemonComponent;